import { createSelector, createFeatureSelector } from '@ngrx/store';
import { PlansState } from './subscription-plans.reducer';

export const selectPlansState = createFeatureSelector<PlansState>('subscriptionPlans');

export const selectFetchedPlans = createSelector(selectPlansState, (state: PlansState) => state.fetchedPlans);
